module.exports = __webpack_public_path__ + "img/Icon ionic-ios-search-white.5b03a7b0.svg";